import React, {useState } from "react";
import {
  Box,
  Grid,
  Tabs,
  Tab,
  Typography,
} from "@mui/material";
import Users from "./Users/Users";
import Roles from "./Roles/Roles";


function TabPanel(props: { children?: React.ReactNode; index: number; value: number }) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      {...other}
      style={{ paddingTop: "1rem" }}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const UserManagement = () => {
  const [value, setValue] = useState(0); // 0: Users, 1: Roles

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Typography variant="h5" fontSize="34px" mb={2}>
          User Management
        </Typography>
      </Grid>
      <Grid size={12}>
        <Box sx={{ width: "100%" }}>
          {/* Styled Tabs */}
          <Box
            sx={{
              display: "inline-flex",
              backgroundColor: "grey.200",
              padding: "4px",
              borderRadius: "8px",
              mb: 2,
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="User Management Tabs"
              TabIndicatorProps={{ style: { display: "none" } }}
            >
              {["Users", "Roles"].map((label, index) => (
                <Tab
                  key={label}
                  label={label}
                  sx={{
                    textTransform: "none",
                    borderRadius: "6px",
                    px: 3,
                    py: 1.5,
                    fontSize: "0.875rem",
                    fontWeight: 500,
                    color: value === index ? "black" : "text.secondary",
                    backgroundColor: value === index ? "background.paper" : "transparent",
                    transition: "all 0.2s ease",
                    "&:hover": {
                      backgroundColor: value === index ? "background.paper" : "action.hover",
                    },
                  }}
                />
              ))}
            </Tabs>
          </Box>

          {/* Tabs content */}
          <TabPanel value={value} index={0}>
            <Users />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Roles createdBy={""} />
          </TabPanel>
        </Box>
      </Grid>
    </Grid>
  );
};

export default UserManagement;
